(function() {
    'use strict';

    angular.module('ksef')
        .controller('KsefCompanyCreateController', KsefCompanyCreateController);

    KsefCompanyCreateController.$inject = [
        '$state',
        'notificationSrvc',
        'ksefCompanyDataSrvc',
        'ksefCompanyMessagesConst',
        'errorNotificationSrvc'
    ];

    function KsefCompanyCreateController(
        $state,
        notificationSrvc,
        ksefCompanyDataSrvc,
        ksefCompanyMessagesConst,
        errorNotificationSrvc
    ) {
        var self = this;

        self.serverErrors = {
            name: [],
            nip: [],
            nonFieldErrors: []
        };

        self.companyData = {
            name: '',
            nip: ''
        };

        self.createCompany = createCompany;
        self.cleanErrors = cleanErrors;

        function createCompany() {
            ksefCompanyDataSrvc.create(
                self.companyData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification('success', ksefCompanyMessagesConst.add);
                    $state.go('layout.ksef-companies.detail', {pk: response.pk});
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();

